import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import data from 'emoji-mart/data/apple.json'

import {
  NoteIcon as NoteIconLogo, // otherwise name clash with exported component
  CircleEmptyIcon,
  CircleIcon,
  SquareEmptyIcon,
  SquareIcon,
  TriangleEmptyIcon,
  TriangleIcon,
  PieEmptyIcon,
  PieIcon,
  ArcBottomLeftIcon,
  ArcTopRightIcon,
  CircleHalfIcon,
} from 'components/Utils/Icons'
import EmojiViewer from 'components/Utils/Emoji/Viewer'

const CollectionIcons = {
  'circle-empty': CircleEmptyIcon,
  'circle-full': CircleIcon,
  'square-empty': SquareEmptyIcon,
  'square-full': SquareIcon,
  'triangle-empty': TriangleEmptyIcon,
  'triangle-full': TriangleIcon,
  'pie-empty': PieEmptyIcon,
  'pie-full': PieIcon,
  'arc-bottom-left': ArcBottomLeftIcon,
  'arc-top-right': ArcTopRightIcon,

  // legacy naming fallbacks
  'circle-half': CircleHalfIcon,
  triangle: TriangleIcon,
}

export default function NoteIcon({
  iconShape,
  iconColor,
  hasChildren = false,
  size = 14,
  ...wrapperProps
}) {
  const emoji = data.emojis[iconShape]
  if (emoji) {
    return (
      <NoteIconWrapper {...wrapperProps} size={size}>
        <EmojiViewer emoji={emoji} size={size} fontSize={size - 1} />
      </NoteIconWrapper>
    )
  }

  const LegacyCollectionIcon = CollectionIcons[iconShape]
  if (LegacyCollectionIcon) {
    return (
      <NoteIconWrapper {...wrapperProps} size={size}>
        <LegacyCollectionIcon size={size - 2} style={{ color: iconColor }} />
      </NoteIconWrapper>
    )
  }

  return (
    <NoteIconWrapper {...wrapperProps} size={size}>
      <NoteIconLogo size={size - 2} />
    </NoteIconWrapper>
  )
}

NoteIcon.propTypes = {
  iconShape: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.any,
}

NoteIcon.defaultProps = {
  style: {},
}

function NoteIconWrapper({
  className,
  style,
  children,
  size = 14,
  ...otherProps
}) {
  return (
    <div
      className={classNames('flexbox flexbox-centered', className)}
      style={{
        height: size,
        width: size,
        ...style,
      }}
      {...otherProps}
    >
      {children}
    </div>
  )
}
